import React from 'react';

import './MenuItem.css';
import { kevo } from '../../constants/images';

export const MenuItem = ({ title, price, tags, image }) => (
  <div className="app__menuitem">
    <div className="app__menuitem-head">
      <div className="app__menuitem-name">
        <p className="p__cormorant" style={{ color: '#000000' }}>{title}</p>
      </div>
      {/* <div className="app__menuitem-dash" /> */}
      <div className="app__menuitem-price">
        {/* <p className="p__cormorant">{price}</p> */}
      </div>
    </div>

    <div className="app__menuitem-sub">
      <img src={image} className="app__menuitem-img" style={{ marginTop: 15}} />
      <p className="p__opensans" style={{ color: '#000000' }}>{tags}</p>
    </div>
  </div>
);

// export default MenuItem;
